import { render } from "./Table.vue?vue&type=template&id=51c35c98&scoped=true"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"

import "./Table.vue?vue&type=style&index=0&id=51c35c98&scoped=true&lang=css"

import exportComponent from "D:\\Coding\\welikethespeech\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51c35c98"]])

export default __exports__